import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-edit\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"#FF5630\" fill-rule=\"evenodd\" d=\"M13.669 2.56a1.51 1.51 0 0 1-.015 2.137L7.192 11.16l-2.131.01.01-2.13 6.461-6.463a1.51 1.51 0 0 1 2.137-.015m-.717.718a.5.5 0 0 0-.642-.054l-.07.06-6.164 6.162-.004.71.711-.003 6.164-6.163a.505.505 0 0 0 .062-.643zM14 13.986v-1H2v1z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol